import * as Vidim from 'vidim';
theme.Vidim = Vidim; 